import React from 'react';
import { Star, Quote, MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      quote: "I was having intense gas acidity and bloating due to stress and anxiety. I reached out to Preeti for help, and she, with her healing, helped me a lot to overcome this. Though the process is on, I am feeling much better than before. Thank you for the help Preeti.",
      author: "Verified Client",
      role: "Stress & Anxiety Relief",
      type: "Pranic Healing",
      rating: 5
    },
    {
      id: 2,
      quote: "Thank you Preeti ji for your healing. After 1st healing my pain was 60% gone. After 2nd healing I was completely cured. No pain. Thanks for healing.",
      author: "Verified Client",
      role: "Pain Relief Healing",
      type: "Pain Management",
      rating: 5
    },
    {
      id: 3,
      quote: "Final feedback: Thank you so much for the healing, the acidity was so severe that even medicines were not working. After taking healing from Preeti I was relieved.",
      author: "Verified Client",
      role: "Acidity & Recovery",
      type: "Holistic Healing",
      rating: 5
    },
    {
      id: 4,
      quote: "Thank you Preeti... I just got an offer for a Sr. Manager role today... Thanks a lot!",
      author: "Verified Client",
      role: "Career & Life Energy",
      type: "Energy Alignment",
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="scroll-mt-24 bg-white px-6 py-20 lg:px-8 lg:py-28">
      <div className="mx-auto max-w-7xl">
        {/* Header */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.7 }}
          className="mx-auto max-w-3xl text-center"
        >
          <span className="mb-3 inline-block rounded-full bg-lotus-petal/60 px-4 py-1 text-xs font-semibold uppercase tracking-[0.25em] text-lotus-deep">
            Client & Partner Feedback
          </span>
          <h2 className="font-serif text-3xl leading-tight text-lotus-ink sm:text-4xl lg:text-5xl">
            Words of Healing & Trust
          </h2>
          <p className="mt-4 text-base text-lotus-ink/70 sm:text-lg">
            Read real client feedback on how Lotus Prana's energy healing and holistic wellness sessions have transformed lives.
          </p>
        </motion.div>

        {/* Testimonial Cards */}
        <div className="mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item, idx) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.7, delay: idx * 0.15 }}
              whileHover={{ y: -6 }}
              className="flex flex-col justify-between rounded-3xl bg-background p-8 border border-lotus-petal/70 transition-all duration-300 hover:shadow-xl hover:border-lotus-deep/40"
            >
              <div>
                {/* Rating & Type */}
                <div className="flex items-center justify-between mb-6">
                  <div className="flex gap-1 text-amber-500">
                    {[...Array(item.rating)].map((_, i) => (
                      <Star key={i} size={16} fill="currentColor" />
                    ))}
                  </div>
                  <span className="text-[10px] font-semibold uppercase tracking-widest text-lotus-deep/80 bg-lotus-petal/40 px-2.5 py-1 rounded-full">
                    {item.type}
                  </span>
                </div>

                <Quote size={32} className="text-lotus-deep/30 mb-3" />
                <p className="text-sm leading-relaxed text-lotus-ink/80 italic font-serif">
                  "{item.quote}"
                </p>
              </div>

              <div className="mt-8 border-t border-lotus-petal/60 pt-4">
                {/* <h4 className="font-serif text-lg font-medium text-lotus-ink">
                  {item.author}
                </h4> */}
                <p className="text-xs text-lotus-ink/60 mt-0.5">
                  {item.role}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* WhatsApp Consultation Prompt */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-14 text-center"
        >
          <motion.a
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            href="https://api.whatsapp.com/send?phone=+919088771406&text=Hi%20Lotus%20Prana%2C%20I%20read%20the%20testimonials%20and%20would%20like%20to%20know%20more%20about%20your%20healing%20packages."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-lotus-deep hover:text-lotus-deep/80 transition-colors"
          >
            <MessageCircle size={16} />
            <span>Have Questions? Connect directly on WhatsApp</span>
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;

